import styled from "styled-components";

export const StyledTabPanel = styled.div`
    height: 100%;
    max-height: 100%;
    overflow: hidden;
`